import React from 'react';
import { graphql } from 'gatsby';
import { LinkList as LinkListComponent } from '../../LinkList';
import { Section } from '../../Section';

export const LinkList = ({ data, ...rest }) => (
  <Section contained narrow={data.width === 'narrow'} {...rest}>
    <LinkListComponent {...data} {...rest} />
  </Section>
);

export const LinkListQuery = graphql`
  fragment LinkList on KFH_UmbracoLinkListComponentType {
    title
    smallHeading
    lead
    addBorder
    items {
      link {
        url
        type
        target
        name
      }
    }
  }
`;
